import { useEffect, useRef, useState } from 'react';
import eventBus from "../../utils/eventBus";
import NavCard from "./NavCard.js";
import { Box } from '@mui/material'

const sx = {
  h100: {
    height: "100%"
  }
}


export default function Cta({ token, onDisclosureClick }) {
  const divRef = useRef(null)
  const navCtaWidgetRef = useRef(null)
  const [cta, setCta] = useState(null)

  const env = process.env['REACT_APP_NAV_ENV'];
  const contentSpace = process.env['REACT_APP_NAV_SPACE'];
  const partner = process.env['REACT_APP_NAV_PARTNER'];

  function openNav() {
    navCtaWidgetRef.current.submit();
  }

  useEffect(() => {
    try {
      import(/* webpackIgnore: true */'https://cdn.skypack.dev/@navinc/cta-widget@1?min').then((module) => {
        const NavCtaWidget = module.default


        navCtaWidgetRef.current = NavCtaWidget({
          element: divRef.current,
          getAuthToken: function () {
            return Promise.resolve(token)
          },
          env,
          contentSpace,
          partner,
        })

        navCtaWidgetRef.current.on('cta', ({ cta }) => {
          setCta(cta)
        })

        navCtaWidgetRef.current.on('modalWindow', ({ type }) => {
          if (type === 'open') {
            document
              .querySelector('div[data-testid="mof:shadow"]')
              ?.shadowRoot.querySelector('.Modal')
              ?.setAttribute('style', 'margin-top:80px')
          }
        })

        navCtaWidgetRef.current.init()

        eventBus.on('openNav', openNav)
      }).catch((e) => {
        console.error(e);
      });

      return () => {
        navCtaWidgetRef.current?.cleanup()
        eventBus.off('openNav', openNav)
      }
    } catch (e) {
      console.error(e);
    }
  }, [token, env, contentSpace, partner])

  return (
    <Box sx={sx.h100}>
      <Box sx={sx.h100} ref={divRef}>
        {cta &&
          <NavCard
            imageURL={cta.imageURL}
            title={cta.title}
            body={cta.body}
            buttonText={cta.linkText}
            navData={cta.additionalDetails}
            onDisclosureClick={onDisclosureClick}
          >
          </NavCard>
        }
      </Box>
    </Box>
  )
}